import React, { useContext, useEffect, useState } from 'react';
import { useQuery } from 'react-query';

// import '@ant-design/compatible/assets/index.css';


import { Col, Input, Row, Switch, Divider, Spin } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import Form, { FormInstance } from 'antd/lib/form';
import { getThirdPartyById } from 'services/thirdParty';
import AddresseListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/AddressesListSelect';
import Text from 'antd/lib/typography/Text';
import Value from 'components/Value';
import Title from 'components/Title';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Address from 'components/address';
import { AuthContext } from 'components/Auth/Auth';
import ParListSelect from 'components/ParListSelect/ParListSelect';

export type TabTPAddressProps = {
  objectid?: number;
  form: FormInstance;
  setSuccessful: any;
};

const TabTPChangeAddress = ({
  objectid,
  form,
  setSuccessful,
}: TabTPAddressProps) => {
  // eslint-disable-next-line no-unused-vars
  const [state, setState] = useState<any>({
    address: {},
    generalData: {},
  });
  const { isInspect } = useContext(AuthContext);
  // eslint-disable-next-line no-unused-vars
  const { data, refetch, isFetching } = useQuery(
    ['getThirdPartyById', { tpid: objectid }],
    () => getThirdPartyById({ tpid: objectid! }).then((res) => res.data),
    { enabled: false }
  );

  useEffect(() => {
    setSuccessful(isFetching);
    
  }, [isFetching]);

  useEffect(() => {
    refetch();
    form.setFieldsValue({
      event: 'tabTPChangeAddress',
    });
  }, [refetch]);

  return (
    <DF.Provider pagcode="tabTPChangeAddress">
      <Spin spinning={isFetching}>
        <Row gutter={8}>
         
        <Col xs={3}>
                <FormInput name="flagapplytoall" noStyle>
                  <Switch
                    checkedChildren={<GetLabel label="change&apply" />}
                    unCheckedChildren={<GetLabel label="only&add" />}
                   
                  />
                </FormInput>
              </Col>
              
              
          <Col span={24}>
          <Divider orientation="left"></Divider>
          {form.getFieldValue('flagapplytoall')===true&&(<div>
            <Row>
              <Title comcode="addressToReplace" level={4} />
            </Row>
            <Row>
              <Col span={24}>&nbsp;</Col>
            </Row>
            <Row gutter={16}>
              <Col xs={12}>
                <FormInput name="tpadrid" comcode="selectAddress">
                  <AddresseListSelect
                    params={{ tpid: objectid ?? 0 }}
                    onSelected={(e) =>
                      form?.setFieldsValue({
                        adrtypelabel: e?.adrtypelabel ?? 'MAIN',
                        adrtype: e?.adrtype ?? 'MAIN',
                      })
                    }
                  />
                </FormInput>
              </Col>
              <Col xs={2}>
                <Text>
                  <GetLabel label="thisAddressIs" />
                </Text>
              </Col>
              <Col xs={4}>
                <FormInput
                  noStyle
                  name="adrtypelabel"
                  style={{ color: 'blue' }}
                >
                  <Value />
                </FormInput>
                <Form.Item noStyle name="adrtype" hidden style={{ color: 'blue' }}>
                  <Input  />
                </Form.Item>
              </Col>
            </Row>
            <Divider orientation="left"></Divider>
            </div>)}
            
            <Row>
              <Title comcode="newAddressDetail" level={4} />
            </Row>

            <Row gutter={8}>
             
              <FormInput col xs={5} name="adrtype">
                  <ParListSelect parcode='ADRTYPE'  />
                  </FormInput>
          
              <FormInput
                col
                xs={10}
                name="tpmainadrstreet1"
                rules={[
                  { required: true, message: 'tpmainadrstreet1 is mondatory' },
                ]}
              >
                <Input />
              </FormInput>

              <FormInput col xs={10} name="tpmainadrstreet2">
                <Input />
              </FormInput>
            </Row>
            <Row gutter={8}>
              <Address
                form={form}
                paysField="tpmainadrcountry"
                regionField="tpmainadrregion"
                villeField="tpmainadrcity"
                codePostalField="tpmainadrzipcode"
                spanGlobalRegion={5}
                spanZip={5}
                spanRegion={5}
                spanCountry={5}
               addValue={  localStorage?.getItem('userrole')==='ADMIN'}
              />
             
            </Row>
          </Col>
        </Row>
      </Spin>
    </DF.Provider>
  );
};
export default TabTPChangeAddress;
